export default "__VITE_ASSET__D6qEd5yz__"